import { useMemo } from 'react';
import type { ReactNode } from 'react';
import { App as AntdApp, ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';
import { ThemeModeProvider, createAdminTheme, useThemeMode } from '@goelectric/ui-components';
import { AuthProvider } from '@/features/auth/context/AuthContext';

/** ConfigProvider de antd alimentado con los tokens del tema resuelto. */
function ThemedShell({ children }: { children: ReactNode }) {
  const { resolvedTheme } = useThemeMode();
  const theme = useMemo(() => createAdminTheme(resolvedTheme), [resolvedTheme]);
  const locale = useMemo(() => esES, []);

  return (
    <ConfigProvider theme={theme} locale={locale}>
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
}

/** Composición de providers de la aplicación (tema → antd → sesión). */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeModeProvider>
      <ThemedShell>
        <AuthProvider>{children}</AuthProvider>
      </ThemedShell>
    </ThemeModeProvider>
  );
}
